<template>
  <div>
    <v-container>
      <v-row>
        <v-col md="6" class="text-left">
          <button class="btn primary white--text font-weight-bold" @click="createRaces('create_races')">{{ $tc("dashboard.menu.createRace.createRaces") }}</button>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <RaceEventList v-bind:event="event" :heightTab="250" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import RaceEventList from "@/components/dashboard/RaceList/RaceEventList.vue";

export default {
  name: "EventRaces",
  components: {
    RaceEventList
  },
  props: ["response"],
  data () {
    return {
      event: null
    }
  },
  methods: {
    createRaces(component) {
      let name = "";
      let params = {};
      if(component == "create_races") {
        name = "RacesCreate";
        params = { id: this.$route.params.id }
      }
      if (this.$route.name !== name) {
        this.$router.push({
          name, params
        });
      }
    },
    loadEvent() {
      const { success, message } = this.response;
      if(success) {
        this.event = message[0];
      } else
        this.event = null;
    }
  },
  mounted () {
    this.loadEvent();
  }
};
</script>
